export const purpleMui = {
  /**
   * Preview: ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png)
   */
  _50: "#f3e5f5",
  /**
   * Preview: ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png)
   */
  _100: "#e1bee7",
  /**
   * Preview: ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png)
   */
  _200: "#ce93d8",
  /**
   * Preview: ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png)
   */
  _300: "#ba68c8",
  /**
   * Preview: ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png)
   */
  _400: "#ab47bc",
  /**
   * Preview: ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png)
   */
  _500: "#9c27b0",
  /**
   * Preview: ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png)
   */
  _600: "#8e24aa",
  /**
   * Preview: ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png)
   */
  _700: "#7b1fa2",
  /**
   * Preview: ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png)
   */
  _800: "#6a1b9a",
  /**
   * Preview: ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png)
   */
  _900: "#4a148c",
  /**
   * Preview: ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png)
   */
  A100: "#ea80fc",
  /**
   * Preview: ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png)
   */
  A200: "#e040fb",
  /**
   * Preview: ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png)
   */
  A400: "#d500f9",
  /**
   * Preview: ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
   */
  A700: "#aa00ff",
};
